import {isElitefoto, useAPI} from "../../../../lib/common";
import React, {useEffect, useState} from "react";
import AppBar from "../../Components/AppBar";
import {Container} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon/ListItemIcon";
import Radio from "@material-ui/core/Radio/Radio";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import Box from "@material-ui/core/Box";
import {formatCurrency} from "../../../../utils";
import Button from "@material-ui/core/Button";
import {Link as RouterLink, Redirect, useHistory} from "react-router-dom";
import ShippingForm from "./Components/ShippingForm";
import StoreSelect from "./Components/StoreSelect";
import PickupLocation from "./Components/PickupLocation";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useCheckout} from "../../Providers/CheckoutProvider";
import StorePickupForm from "./Components/StorePickupForm";
import Checkbox from "@material-ui/core/Checkbox";
import {useShoppingCart} from "../../hooks/shoppingcart";
import {getNavigationUrl} from "../../navigation";
import {useAuth} from "../../hooks/auth";
import PickupLocationSpeed from "./Components/PickupLocationSpeed";
import {Trans, useTranslation} from "react-i18next";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import useTheme from "@material-ui/core/styles/useTheme";
const sprintf = require('sprintf-js').sprintf;

const useStyles = makeStyles(theme => ({
  button: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  listItem: {
    backgroundColor: '#F6F6F6',
    marginBottom: '2px'
  },
  selected: {
    '&.MuiListItem-root, &.MuiListItem-root:active, &.MuiListItem-root:hover': {
      backgroundColor: theme.palette.secondary.light
    }
  },
  root: {
    '& .MuiTextField-root': {
      marginBottom: theme.spacing(1),
    },
  },
  card: {
    backgroundColor: 'white',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: '0px 2px 4px #00000029',
  }
}));


export default () => {
  const {state, setDeliveryType, setDeliveryOption} = useCheckout();
  const [deliveryTypes, loading] = useAPI('/m/api/checkout/delivery-options')
  const classes = useStyles();
  const { items } = useShoppingCart();
  const {t} = useTranslation();
  const theme = useTheme();
  const disableGutters = useMediaQuery(theme.breakpoints.down('sm'));

  console.log('State is', state);

  useEffect(() => {
    if (!deliveryTypes) {
      return;
    }
    if (deliveryTypes.length == 1) {
      handleSetDeliveryType(deliveryTypes[0]);
    }

    // if we have delivery option:
    if (state.deliveryOption) {
      for (let deliveryType of deliveryTypes) {
        console.log('Delivery type', deliveryType);
          if (deliveryType.type == 'store-pickup' && deliveryType.pickupLocations.find(d => {
            console.log('Compare', d.uuid, state.deliveryOption.uuid);
            return d.uuid === state.deliveryOption.uuid
          })) {
            // Found:
            setDeliveryType(deliveryType);
            return;
          }
          else if (deliveryType.deliveryOptions.find(d => {
            console.log('Compare', d.uuid, state.deliveryOption.uuid);
            return d.uuid === state.deliveryOption.uuid
          })) {
            // Found:
            setDeliveryType(deliveryType);
            return;
          }
      }
    }

    // If we have in store, select it:
    const inStore = deliveryTypes.find(dt => dt.type == 'store-pickup');
    if (inStore) {
      handleSetDeliveryType(inStore)
    }
  }, [deliveryTypes]);

  const handleSetDeliveryType = (deliveryType) => {
     setDeliveryType(deliveryType);
     setDeliveryOption(null);
     if (deliveryType.deliveryOptions && deliveryType.deliveryOptions.length == 1) {
       // We only got one option:
       setDeliveryOption(deliveryType.deliveryOptions[0]);
     }
     else if (deliveryType.type == 'store-pickup' && deliveryType.pickupLocations.filter(pl => pl.uuid.substring(24) !== "111111111111").length == 1) {
       setDeliveryOption(deliveryType.pickupLocations[0]);
     }
  }

  if (loading) {
    return <div>Loading</div>
  }

  // If we items, redirect to shopping cart:
  if (items.length == 0) {
    return <Redirect to={getNavigationUrl('SHOPPING_CART')} />
  }


  console.log('Delivery type', state.deliveryType);
  console.log('Rendering delivery option', state.deliveryOption);

  let days = 5;
  return <React.Fragment>
    <AppBar />

    <Container disableGutters={disableGutters} maxWidth="sm">
      <div className={classes.card}>
        <Typography variant="h4">
          <Trans>Delivery</Trans>
        </Typography>
        <Typography variant="h6">
          <Trans>Choose delivery option</Trans>
        </Typography>
        <List>
          {deliveryTypes.sort((a, b) => {
            // Stupid sort to get store pickup first:
            if (a.type == 'store-pickup') {
              return -1;
            }
            return 1;
          }).map((dt) => {
            const labelId = dt.type;
            let description = '';
            switch (dt.type) {
              case "store-pickup":
                description =
                    t("Choose this option if you want to pickup the order in our store")
                break;
              case "postage":
                let days = parseInt(dt.deliveryOptions[0].deliverytime);
                if (days > 1) {
                  description = t('The order will be shipped within %d business days', {
                    postProcess: 'sprintf',
                    sprintf: [days]
                  })
                } else {
                  description = t('The order will be shipped within %d business day', {
                    postProcess: 'sprintf',
                    sprintf: [days]
                  })
                }
                break;
            }
            console.log('Label is', labelId);
            console.log('Delivery option', dt);
            return <ListItem key={dt.type} button selected={state.deliveryType && dt.type === state.deliveryType.type}
                             classes={{selected: classes.selected}}
                             onClick={() => handleSetDeliveryType(dt)} className={classes.listItem}>
              <ListItemIcon>
                <Radio edge="start"
                       checked={state.deliveryType && dt.type === state.deliveryType.type}
                       inputProps={{'aria-labelledby': labelId}}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={dt.name} secondary={description}/>
              <Box style={{whiteSpace: 'nowrap'}}>{formatCurrency(dt.price)}</Box>
            </ListItem>
          })}
        </List>
      </div>
    </Container>

   {state.deliveryType && <Container disableGutters={disableGutters} maxWidth="sm">
     <div className={classes.card}>
       <DeliveryTypeOptions deliveryType={state.deliveryType}/>
     </div>
   </Container>}

  </React.Fragment>
}

const DeliveryTypeOptions = ({deliveryType}) => {
  switch (deliveryType.type) {
    case "postage":
      return <PostageOptions deliveryType={deliveryType}/>
    case "store-pickup":
      return <StorePickupOptions deliveryType={deliveryType}/>
  }
  return null;
}

const PostageOptions = ({deliveryType}) => {
  const { state, updateCustomerInfo } = useCheckout();
  const history = useHistory();
  const { user } = useAuth()


  const handleSubmit = (data) => {
    updateCustomerInfo(data)
    history.push('/cart/checkout/payment-options')
  }

  console.log('User is', user);

  return <Box>
    <Typography variant="h4" gutterBottom>
      <Trans>Delivery address</Trans>
    </Typography>
    <ShippingForm customerInfo={state.customerInfo} user={user} onSubmit={handleSubmit}/>
  </Box>
}

const StorePickupOptions = ({deliveryType}) => {
  const classes = useStyles();
  const {state, setDeliveryOption, updateCustomerInfo} = useCheckout();
  const {user} = useAuth()
  const history = useHistory();

  const handlePickupLocation = (pickupLocation) => {
    setDeliveryOption(pickupLocation)
  }

  const handleSubmit = (data) => {
    updateCustomerInfo(data)
    history.push('/cart/checkout/payment-options')
  }

  const realPickupLocations = deliveryType.pickupLocations
    .filter(pl => {
      if (pl.uuid.substring(24) === "111111111111") {
        return false;
      }
      if (isElitefoto() && !pl.pickupregion) {
        return false;
      }
      return true;
    });

  return <Box>
      <Typography variant="h4" gutterBottom>
        <Trans>Pickup in store</Trans>
      </Typography>
      {realPickupLocations.length > 1 &&
        <StoreSelect deliveryType={deliveryType} setPickupLocation={handlePickupLocation}
                   pickupLocation={state.deliveryOption}/>
      }
      {state.deliveryOption && <PickupLocation pickupLocation={state.deliveryOption}/>}

    {state.deliveryOption &&
    <PickupLocationSpeed pickupLocation={state.deliveryOption} deliveryType={deliveryType}
                         setPickupLocation={handlePickupLocation}/>}

    <StorePickupForm customerInfo={state.customerInfo} user={user} onSubmit={handleSubmit}/>

  </Box>
}